import Swiper, { Lazy, Navigation, Thumbs, FreeMode } from "swiper";
import "swiper/scss";
import "swiper/scss/lazy";
import "swiper/scss/free-mode";
import "swiper/scss/thumbs";
import "swiper/scss/navigation";
import SnapSlider from "./modules/slider";
import Tabs from "./modules/tabs";
// import Twig from 'twig';
import { moneyFormat } from "./modules/functions";
const { __, _n } = wp.i18n;

const swiperThumbCarGallery = new Swiper(
	document.getElementById("swiper_thumb_car_gallery"),
	{
		modules: [FreeMode],
		spaceBetween: 10,
		slidesPerView: 3.5,
		watchSlidesProgress: true,
		freeMode: true,
		breakpoints: {
			768: {
				slidesPerView: 4.5,
			},
		},
	}
);

const swiperAuctionCarGallery = new Swiper(
	document.getElementById("swiper_auction_car_gallery"),
	{
		modules: [Lazy, Thumbs, Navigation],
		slidesPerView: 1,
		thumbs: {
			swiper: swiperThumbCarGallery,
		},
		navigation: {
			nextEl: ".auction-car-gallery-next",
			prevEl: ".auction-car-gallery-prev",
			hiddenClass: "hidden",
		},
	}
);

new Tabs("tabs", "tab-contents");
